import { render, staticRenderFns } from "./uploadOriImg.vue?vue&type=template&id=cf753678&scoped=true&"
import script from "./uploadOriImg.vue?vue&type=script&lang=js&"
export * from "./uploadOriImg.vue?vue&type=script&lang=js&"
import style0 from "./uploadOriImg.vue?vue&type=style&index=0&id=cf753678&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf753678",
  null
  
)

export default component.exports